import { render } from "./TrialSheetDataPage.vue?vue&type=template&id=87cd0d20&scoped=true"
import script from "./TrialSheetDataPage.vue?vue&type=script&lang=js"
export * from "./TrialSheetDataPage.vue?vue&type=script&lang=js"

import "./TrialSheetDataPage.vue?vue&type=style&index=0&id=87cd0d20&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87cd0d20"]])

export default __exports__